import { Action, Network } from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getProbeDomainKey } from '../../utils/keys/domain.key.js'
import { getNetworkKey } from '../../utils/keys/network.key.js'

export const useCancelDomainTransfer = (options?: {
  useMutationOptions?: UseMutationOptions<Action, Error>
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, Error>(
    () => client.network.cancelDomainTransfer(),
    {
      onSuccess: () => {
        const networkKey = getNetworkKey()
        const probeKey = getProbeDomainKey()
        queryClient.setQueriesData<Network>(networkKey, old => {
          return {
            ...old,
            newDomain: null,
          }
        })
        queryClient.invalidateQueries(networkKey)
        queryClient.invalidateQueries(probeKey, undefined, {
          cancelRefetch: true,
        })
      },
      ...useMutationOptions,
    },
  )
}
